import { render, staticRenderFns } from "./ConversationsHistory.vue?vue&type=template&id=3cf36e12&"
import script from "./ConversationsHistory.vue?vue&type=script&lang=js&"
export * from "./ConversationsHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports